module.exports = __webpack_public_path__ + "fk.12d25ef6aeae7d25bee1.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/fk.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/fk.svg
// module chunks = styles